import { devtools as _devtools } from 'zustand/middleware';

const devtools = process.env.NODE_ENV === 'development' ? _devtools : (((fn) => fn) as typeof _devtools);

export default devtools;
